const initMappedImage = () => {
    const mappedImageWidgetsList = document.querySelectorAll("[data-pin-image-widget]");
    const body = document.querySelector("body");
    if (mappedImageWidgetsList && mappedImageWidgetsList.length > 0) {
        mappedImageWidgetsList.forEach((mappedImageWidget) => {
            if (mappedImageWidget.getAttribute("data-scrollable") == "True") {
                grabScrollableImage(mappedImageWidget);
            }
            const mappedImage = mappedImageWidget.querySelector("[name='image-map']");
            const image = mappedImageWidget.querySelector("[data-image-pin]");
            if (mappedImage) {
                const areaMappedImageList = mappedImage.querySelectorAll("area");
                // Create a new MutationObserver
                const observer = new MutationObserver((mutationsList, observer) => {
                    mutationsList.forEach((mutation) => {
                        if (mutation.type === "attributes" && mutation.attributeName === "coords") {
                            // The coords attribute of an area has changed
                            const areaMappedImage = mutation.target;
                            const div = document.querySelector(`[data-pin="${areaMappedImage.getAttribute("title")}"]`);
                            // Update the position of the corresponding DIV
                            const [x, y, r] = areaMappedImage.coords.split(",").map(Number);
                            div.style.left = `${x - r}px`;
                            div.style.top = `${y - r}px`;
                            div.style.width = `${r * 2}px`;
                            div.style.height = `${r * 2}px`;
                        }
                    });
                });
                areaMappedImageList.forEach((areaMappedImage) => {
                    const pinModalList = document.querySelectorAll("[data-pin-modal]");
                    observer.observe(areaMappedImage, { attributes: true });
                    // Create the div of the pin base on the coords of area
                    const div = document.createElement("div");
                    //.map(Number) convert the strings into numbers
                    const [x, y, r] = areaMappedImage.coords.split(",").map(Number);
                    div.style.position = "absolute";
                    div.style.left = `${x - r}px`;
                    div.style.top = `${y - r}px`;
                    div.style.width = `${r * 2}px`;
                    div.style.height = `${r * 2}px`;
                    div.style.borderRadius = `50%`;
                    div.classList.add("pin");
                    div.setAttribute("data-pin", `${areaMappedImage.getAttribute("title")}`);
                    // Create dynamic SVG 
                    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    svg.setAttribute("width", `${r * 2}`);
                    svg.setAttribute("height", `${r * 2}`);
                    svg.setAttribute("viewBox", `0 0 ${r * 2} ${r * 2}`);
                    div.appendChild(svg);
                    const circle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                    circle1.setAttribute("cx", `${r}`);
                    circle1.setAttribute("cy", `${r}`);
                    circle1.setAttribute("r", `${r}`);
                    circle1.setAttribute("fill", "white");
                    circle1.setAttribute("fill-opacity", "0.25");
                    svg.appendChild(circle1);
                    const circle2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                    circle2.setAttribute("cx", `${r}`);
                    circle2.setAttribute("cy", `${r}`);
                    circle2.setAttribute("r", `${r - 11.5}`);
                    circle2.setAttribute("fill", "black");
                    circle2.setAttribute("fill-opacity", "0.1");
                    circle2.setAttribute("stroke", "#444444");
                    circle2.setAttribute("stroke-width", "3");
                    svg.appendChild(circle2);
                    const circle3 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                    circle3.setAttribute("cx", `${r}`);
                    circle3.setAttribute("cy", `${r}`);
                    circle3.setAttribute("r", `${r - 17.5}`);
                    circle3.setAttribute("fill", "white");
                    circle3.setAttribute("fill-opacity", "0.5");
                    circle3.setAttribute("stroke", "#444444");
                    svg.appendChild(circle3);
                    const rect1 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                    rect1.setAttribute("x", `${r}`);
                    rect1.setAttribute("y", `${r - 19}`);
                    rect1.setAttribute("width", "2");
                    rect1.setAttribute("height", "38");
                    rect1.setAttribute("fill", "#FF240D");
                    svg.appendChild(rect1);
                    const rect2 = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                    rect2.setAttribute("x", `${r + 20}`);
                    rect2.setAttribute("y", `${r}`);
                    rect2.setAttribute("width", "2");
                    rect2.setAttribute("height", "38");
                    rect2.setAttribute("transform", `rotate(90 ${r + 20} ${r})`);
                    rect2.setAttribute("fill", "#FF240D");
                    svg.appendChild(rect2);
                    // Append the pin
                    image.appendChild(div);
                    // EVENT LISTENER 
                    div.addEventListener("click", (e) => {
                        e.preventDefault();
                        for (let i = 0; i < pinModalList.length; i++) {
                            if (div.getAttribute("data-pin") == pinModalList[i].getAttribute("data-pin-modal")) {
                                pinModalList[i].setAttribute("data-show", "show");
                                body.classList.add("modal-active");
                                if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                                    // The browser is Safari
                                    mappedImageWidget.parentElement.classList.add("modal-active");
                                }
                                const closeIcon = pinModalList[i].querySelector("[data-close-modal-icon]");
                                if (closeIcon) {
                                    closeIcon.addEventListener("click", () => {
                                        pinModalList[i].setAttribute("data-show", "");
                                        body.classList.remove("modal-active");
                                        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
                                            // The browser is Safari
                                            mappedImageWidget.parentElement.classList.remove("modal-active");
                                        }
                                    });
                                }
                            }
                        }
                    });
                });
            }
        });
    }
};
const grabScrollableImage = (mappedImageWidget) => {
    const imageContainer = mappedImageWidget.querySelector("[data-scrollable-image-container]");
    if (imageContainer) {
        let isDown = false;
        let startX;
        let scrollLeft;
        imageContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            imageContainer.classList.add('active');
            startX = e.pageX - imageContainer.offsetLeft;
            scrollLeft = imageContainer.scrollLeft;
        });
        imageContainer.addEventListener('mouseleave', () => {
            isDown = false;
            imageContainer.classList.remove('active');
        });
        imageContainer.addEventListener('mouseup', () => {
            isDown = false;
            imageContainer.classList.remove('active');
        });
        imageContainer.addEventListener('mousemove', (e) => {
            if (!isDown)
                return;
            e.preventDefault();
            const x = e.pageX - imageContainer.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            imageContainer.scrollLeft = scrollLeft - walk;
            console.log(walk);
        });
    }
};
